enum AnswersTabs {
  Answers = 'answers',
  PostQuizAnswers = 'postQuizAnswers',
  PreQuizAnswers = 'preQuizAnswers'
};

export default AnswersTabs;
